import { useStudentAuthContext } from "./useStudentAuthContext";

export const useStudentLogout = () => {

    const { dispatch } = useStudentAuthContext();

    
    const logout = () => {
     //remove user from local storage
     localStorage.removeItem('studentuser');
     //dispatch logout action
     dispatch({type: 'STUDENT_LOGOUT'});
     
    }
    return { logout };
}
